/*globals google*/
angular.module('b2bLoginApp.directives').directive('locationGoogleMap', function () {
    return {
        restrict: 'AE',
        scope: {
            updateresults: "&",
            subscriptions: '=subscriptions',
            subscriptionsSettings: '=subscriptionsSettings',
            iso: '@',
        },
        replace: true,
        controller: ["$scope", "uiGmapGoogleMapApi", function ($scope, uiGmapGoogleMapApi) {
            let setUpTimer;
            let destroyed = false;
            $scope.$on('$destroy', function () {
                destroyed = true;
                clearTimeout(setUpTimer);
            });

            function initMap() {

                const options = {
                    fields: ["formatted_address", "geometry", "name"],
                    strictBounds: false,
                    componentRestrictions:  { country: $scope.iso },
                };
                let autocompletes = [];

                $scope.$watchCollection('subscriptions', function () {
                    setUpAutocompleteForInputs();
                });

                // Use the autocomplete instance that actually fired the event. setUpAutocompleteForInputs
                // rebuilds the array on every subscriptions change, so an index lookup can resolve to a
                // newer, place-less instance and throw on `.geometry` (the place lives on the firing one).
                var onPlaceChanged = function (autocomplete, subscriptionId) {
                    $scope.place = autocomplete.getPlace();
                    if (!$scope.place || !$scope.place.geometry || !$scope.place.geometry.location) {
                        return;
                    }
                    placeLoaded(subscriptionId);
                }

                function listenerHandler(autocomplete, subscriptionId) {
                    return function() {
                        onPlaceChanged(autocomplete, subscriptionId);
                    };
                }

                var setUpAutocompleteForInputs = function () {
                    clearTimeout(setUpTimer);
                    setUpTimer = setTimeout(() => {
                        autocompletes = [];
                        let radiusInputs = document.getElementsByClassName("pac-input");
                        for (var i = 0; i < radiusInputs.length; i++) {
                            let autocomplete = new google.maps.places.Autocomplete(radiusInputs[i], options);
                            autocomplete.inputId = radiusInputs[i].id;
                            autocomplete.addListener('place_changed', listenerHandler(autocomplete, autocomplete.inputId));
                            autocompletes.push(autocomplete);
                        }
                    }, 500);
                }
                setUpAutocompleteForInputs();
            }

            var placeLoaded = function (subscriptionId) {
                $scope.updateresults(
                    {
                        $value: {
                            lat: $scope.place.geometry.location.lat(),
                            long: $scope.place.geometry.location.lng(),
                            label: $scope.place.formatted_address,
                            subscriptionId: subscriptionId,
                        }
                    }
                );
            }

            //Timeout added as all HTML elements required by google widget must be loaded at first
            setTimeout(() => {
                // The Maps API script loads asynchronously; the promise resolves once it and its libraries are ready.
                uiGmapGoogleMapApi.then(function () {
                    if (!destroyed) {
                        initMap();
                    }
                });
            }, 500);
        }]
    };
});
